import BlockTitle from './BlockTitle.tsx';
import ReactPlayer from 'react-player';
import {RichBlockComponentProps} from './blockComponents.tsx';
import {getBestTranslatedValue} from '../../../lib/localeHelper.ts';

import {VideoBlockData} from '../../../types/api.ts';

export default function VideoBlock({
    data: {title, url, translations},
    locale,
    userLocales,
}: RichBlockComponentProps<VideoBlockData>) {
    const resolvedTitle = getBestTranslatedValue(
        translations ?? {},
        'title',
        title,
        locale,
        userLocales,
    );
    const resolvedUrl = getBestTranslatedValue(
        translations ?? {},
        'url',
        url,
        locale,
        userLocales,
    );

    return (
        <>
            <BlockTitle title={resolvedTitle} />
            <div
                style={{
                    borderRadius: '8px',
                    overflow: 'hidden',
                }}
            >
                <ReactPlayer
                    src={resolvedUrl}
                    controls
                    style={{width: '100%', height: 'auto', aspectRatio: '16/9'}}
                />
            </div>
        </>
    );
}
